import React from "react";
import { Box } from "@mui/material";
import { CONTENT_MAX_WIDTH } from "../../constants/layout";

/**
 * Контейнер сторінки: центрує контент, обмежує ширину, задає горизонтальні відступи.
 * @param {boolean} maxWidth - чи обмежувати maxWidth (default true)
 * @param {string} component - HTML element for the container (default 'div')
 */
const PageContainer = ({
  children,
  maxWidth = true,
  component = "div",
  sx = {},
  ...rest
}) => {
  return (
    <Box
      component={component}
      sx={{
        width: "100%",
        maxWidth: maxWidth ? CONTENT_MAX_WIDTH : "100%",
        mx: "auto",
        px: { xs: 2, sm: 3, md: 4 },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default PageContainer;
